const API_ORIGIN = (process.env.REACT_APP_API_URL || 'http://localhost:8082/api').replace(/\/api\/?$/, '');

/** Risolve un URL immagine: assoluto→invariato, /img→dal frontend, path relativo→dal backend. */
export function resolveImg(value?: string): string {
  if (!value) return '';
  if (/^https?:\/\//.test(value) || value.startsWith('/img/')) return value;
  return API_ORIGIN + value;
}
